import React from "react";
import './Header1.css';
import picture1 from './source/picture1.png'
import picture2 from './source/picture2.png'
import picture3 from './source/picture3.png'
import picture4 from './source/picture4.png'



function Header1() {

  return (
    <div className="header1">
      <div className="header1-box1">





        <div className="header1-box2">
          <div className="header1-box4">
            <div className="header1-box7">
            <img className="header1-box7-picture1" src={picture1} alt="picture1"/>
            </div>
            <div className="header1-box8">
            +420 702 898 123  
            </div>
          </div>



          <div className="header1-box5">
            <div className="header1-box9">
            <img className="header1-box9-picture2" src={picture2} alt="picture2"/>
            </div>
            <div className="header1-box10">
            Po-Pa 8:00 - 17:00
            </div>      
          </div>



          <div className="header1-box6">
           <div className="header1-box11">
           <img className="header1-box11-picture3" src={picture3} alt="picture3"/>
           </div>
           <div className="header1-box12">
           sadrokartony-zajgla@seznam.cz
           </div>  
          </div>
        </div>
        



        
        <div className="header1-box3">
          <div className="header1-box13">
          <a href="https://www.facebook.com/profile.php?id=100091169075261"><img className="header1-box13-picture4" src={picture4} alt="picture4"/></a>
          </div>
        </div>


    
      </div>
    </div>
  );
}

export default Header1;
